// src/slices/apiSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import adminAxiosInstance from "../../../api/adminAxiosInstance";
import { endpoints } from "../../../api/endpoints";

export const AddUpdateSubscriptionApi = createAsyncThunk(
  "AddSubscription/AddSubscription",
  async (Data, { rejectWithValue }) => {
    try {
      const response = await adminAxiosInstance.post(
        endpoints.addUpdateSubscription,
        Data
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const GetSubscriptionPlan = createAsyncThunk(
  "AddSubscription/GetSubscriptionPlan",
  async (Data, { rejectWithValue }) => {
    try {
      const response = await adminAxiosInstance.post(
        endpoints.getSubscriptionPlans,
        Data
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const DeleteSubscriptionPlan = createAsyncThunk(
  "AddSubscription/DeleteSubscriptionPlan",
  async (Data, { rejectWithValue }) => {
    try {
      const response = await adminAxiosInstance.post(
        endpoints.deleteSubscriptionPlans,
        Data
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const AddUpdateSubscriptionSlice = createSlice({
  name: "AddUpdateSubscriptionSlice",
  initialState: {
    data: null,
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(AddUpdateSubscriptionApi.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(GetSubscriptionPlan.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(DeleteSubscriptionPlan.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })

      .addCase(AddUpdateSubscriptionApi.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(GetSubscriptionPlan.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(DeleteSubscriptionPlan.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(AddUpdateSubscriptionApi.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(GetSubscriptionPlan.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(DeleteSubscriptionPlan.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});
export default AddUpdateSubscriptionSlice.reducer;
